
export default {
    methods: {

        number_format : function(number, decimals, dec_point, thousands_sep){
            // Show '-' if null
            if(number == null) { return '-'; }
            // Strip all characters but numerical ones.
            number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
            var n = !isFinite(+number) ? 0 : +number,
                prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
                sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
                dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
                s = '',
                toFixedFix = function (n, prec) {
                    var k = Math.pow(10, prec);
                    return '' + Math.round(n * k) / k;
                };
            // Fix for IE parseFloat(0.55).toFixed(0) = 0;
            s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
            if (s[0].length > 3) {
                s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
            }
            if ((s[1] || '').length < prec) {
                s[1] = s[1] || '';
                s[1] += new Array(prec - s[1].length + 1).join('0');
            }
            return s.join(dec);
        },
    
        abbreviateNumber: function(value) {
            var newValue = parseInt(value);
            if (value >= 1000) {
                var suffixes = ["", "k", "m", "b","t"];
                var suffixNum = Math.floor( (""+value).length/3 );
                var shortValue = '';
                for (var precision = 2; precision >= 1; precision--) {
                    shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
                    var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
                    if (dotLessShortValue.length <= 2) { break; }
                }
                if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
                newValue = shortValue+suffixes[suffixNum];
            }
            return newValue;
        },
    
        number_format_wrapper_total : function(value) {
    
            if(window.innerWidth <= 500){
                return this.abbreviateNumber(value);
            }
    
            return this.number_format(value, 0, '.', ',');
        },
    
        number_format_wrapper_plus : function(value) {
            if(value > 0) {
    
                if(window.innerWidth <= 500){
                    return '+'+this.abbreviateNumber(value);
                }
    
                return '+'+this.number_format(value, 0, '.', ',');
            } else {
                return '-';
            }
        },
    
        number_format_wrapper : function(value) {
    
            if(window.innerWidth <= 500){
                return this.abbreviateNumber(value);
            }
    
            return this.number_format(value, 0, '.', ',');
        },
    
        get_query_param: function(name){
    
            var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
            return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
        },
    
        get_partners_utm_string: function(){
    
            var partner     = this.get_query_param('utm_source');
            var medium      = this.get_query_param('utm_medium');
            var campaign    = this.get_query_param('utm_campaign');
    
            var utm_params  = "utm_source=:partner&utm_medium=:medium&utm_campaign=:campaign";
            
            return utm_params.replace(":partner", partner).replace(":medium", medium).replace(":campaign", campaign);
        },

    },
};